/* Product preview under article-body links. The section pre-renders one mini
   card per handle into an inert <template>, so opening costs no request. The
   popover is inert too: a rich tooltip, so hover and focus alone drive it. */
(function () {
  if (window.bqProductPeek) return;
  window.bqProductPeek = true;

  var body = document.querySelector('[data-bq-article-body]');
  if (!body) return;

  var templates = document.querySelectorAll('template[data-bq-peek-handle]');
  if (!templates.length) return;

  var sources = {};
  for (var i = 0; i < templates.length; i++) {
    sources[templates[i].getAttribute('data-bq-peek-handle')] = templates[i];
  }

  // Coarse pointers get no preview: a tap must navigate, not reveal a card.
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var OPEN_DELAY = 190; // long enough that a pointer crossing the link does nothing
  var CLOSE_DELAY = 90; // short grace so link-to-link moves swap instead of blink

  var pop = document.createElement('div');
  pop.className = 'bq-peek';
  pop.id = 'bq-peek';
  pop.setAttribute('role', 'tooltip');

  var cards = {};
  var host = null; // link the popover currently describes
  var pending = null; // link waiting out OPEN_DELAY
  var openTimer = 0;
  var closeTimer = 0;
  var frame = 0;
  var mounted = false;

  function handleOf(link) {
    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (e) {
      return null;
    }
    if (url.host !== window.location.host) return null;
    var found = url.pathname.match(/\/products\/([^/]+)\/?$/);
    if (!found) return null;
    try {
      return decodeURIComponent(found[1]);
    } catch (e) {
      return found[1];
    }
  }

  // Cloned once per handle: later hovers reuse a decoded image.
  function cardFor(handle) {
    if (!cards[handle]) {
      cards[handle] = sources[handle].content.cloneNode(true).firstElementChild;
    }
    return cards[handle];
  }

  function place() {
    if (!host) return;
    var r = host.getBoundingClientRect();
    if (r.bottom < 0 || r.top > window.innerHeight) {
      hide();
      return;
    }
    // offsetWidth/Height ignore translate, so this stays stable while shown.
    var w = pop.offsetWidth;
    var h = pop.offsetHeight;
    var edge = 8;
    var x = r.left + r.width / 2 - w / 2;
    var y = r.top - h - 10;
    if (y < edge) y = r.bottom + 10;
    if (y + h > window.innerHeight - edge) y = Math.max(edge, window.innerHeight - h - edge);
    if (x + w > window.innerWidth - edge) x = window.innerWidth - w - edge;
    if (x < edge) x = edge;
    pop.style.setProperty('--bq-peek-x', Math.round(x) + 'px');
    pop.style.setProperty('--bq-peek-y', Math.round(y) + 'px');
  }

  function show(link) {
    var handle = handleOf(link);
    if (!handle || !sources[handle]) return;
    if (!mounted) {
      document.body.appendChild(pop);
      mounted = true;
    }
    clearTimeout(closeTimer);
    if (host !== link) {
      pop.replaceChildren(cardFor(handle));
      if (host) host.removeAttribute('aria-describedby');
      host = link;
      link.setAttribute('aria-describedby', 'bq-peek');
    }
    // place() hides when the trigger sits outside the viewport, which clears `host`. Showing
    // unconditionally here would strand a card with no owner: nothing could then close it,
    // since place() and hide() both bail on a null host. Reachable through focusin, which
    // opens without a delay, for a link focused off-screen on back-navigation.
    place();
    if (host) pop.setAttribute('data-show', '');
  }

  function hide() {
    clearTimeout(openTimer);
    pending = null;
    pop.removeAttribute('data-show');
    if (host) {
      host.removeAttribute('aria-describedby');
      host = null;
    }
  }

  function open(link, immediate) {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    pending = link;
    if (immediate) {
      show(link);
      return;
    }
    openTimer = setTimeout(function () {
      if (pending === link) show(link);
    }, OPEN_DELAY);
  }

  function close() {
    clearTimeout(openTimer);
    pending = null;
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      // A neighbouring link claimed the popover in the meantime.
      if (!pending) hide();
    }, CLOSE_DELAY);
  }

  function linkFrom(event) {
    if (!event.target || !event.target.closest) return null;
    return event.target.closest('a[href]');
  }

  body.addEventListener('mouseover', function (event) {
    if (!fine.matches) return;
    var link = linkFrom(event);
    if (!link || link === host || link === pending) return;
    open(link, false);
  });

  body.addEventListener('mouseout', function (event) {
    if (!fine.matches) return;
    var link = linkFrom(event);
    if (!link) return;
    // Moving between the link's own children is not a leave.
    if (event.relatedTarget && link.contains(event.relatedTarget)) return;
    close();
  });

  // Focus is deliberate: no intent delay.
  body.addEventListener('focusin', function (event) {
    var link = linkFrom(event);
    if (!link) return;
    open(link, true);
  });

  body.addEventListener('focusout', close);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && host) hide();
  });

  function reflow() {
    if (!host || frame) return;
    frame = requestAnimationFrame(function () {
      frame = 0;
      place();
    });
  }

  // Capture: the desktop layout scrolls .page-wrapper, not the document.
  window.addEventListener('scroll', reflow, true);
  window.addEventListener('resize', reflow);
})();
